module.exports = __webpack_public_path__ + "static/media/logoSvgCap.a6e62d6f.svg";